var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonopatinVerde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9225",
    "data-name": "Group 9225",
    transform: "translate(689 -568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13492",
    "data-name": "Rectangle 13492",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-689 568)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-patinete",
    "data-name": "001-patinete",
    transform: "translate(-677 585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M5.464,63.163a5.451,5.451,0,0,1,4.09,1.847h2.514A7.482,7.482,0,0,0,2.343,61.88,1.154,1.154,0,0,1,1.351,59.8a9.776,9.776,0,0,1,13.268,5.214H24.1l6.568-7.443L27.978,43.309H24.009a1.154,1.154,0,0,1,0-2.309h4.925a1.154,1.154,0,0,1,1.134.94l4.011,21.226a5.459,5.459,0,1,1-2.269.427l-.6-3.153-5.483,6.214a5.766,5.766,0,0,1-5.768,5.589H9.554a5.462,5.462,0,1,1-4.09-9.08Zm25.318,5.464a3.155,3.155,0,1,0,3.744-3.1l.545,2.885a1.154,1.154,0,1,1-2.269.429l-.545-2.884A3.155,3.155,0,0,0,30.781,68.626ZM19.964,69.934a3.464,3.464,0,0,0,3.36-2.616H10.768a5.446,5.446,0,0,1,0,2.616Zm-14.5,1.847a3.155,3.155,0,1,0-3.155-3.155A3.159,3.159,0,0,0,5.464,71.781Z",
    transform: "translate(0 -41)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonopatinVerde);
export default __webpack_public_path__ + "static/media/MonopatinVerde.20429969aa7ca5cf487dcea557bd7129.svg";
export { ForwardRef as ReactComponent };